export default "__VITE_ASSET__9w$ig8CQ__"